
import React , {useState , useEffect , useRef} from 'react';
import ProductTransferService from './product-transfer.service';
import BrandService from '../brand/brand.service';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './product-transfer.scss';
const ProductTransfer = (props) => {
    let frombrandsRef = useRef(null)
    let tobrandsRef = useRef(null)
    let fromproductsRef = useRef(null)
    let toproductsRef = useRef(null)
    const [loadingBrand, setLoadingBrand] = useState(true);
    const [brands, setBrands] = useState([]);
    const [fromBrandValue, setFromBrandValue] = useState('');
    const [fromBrandID, setFromBrandID] = useState(undefined);
    const [toBrandValue, setToBrandValue] = useState('');
    const [toBrandID, setToBrandID] = useState(undefined);
    const [loadingProduct, setLoadingProduct] = useState(true);
    const [products, setProducts] = useState([]);
    const [formProductValue, setFromProductValue] = useState('');
    const [fromProductID, setFromProductID] = useState(undefined);
    const [toProductValue, setToProductValue] = useState('');
    const [toProductID, setToProductID] = useState(undefined);

    const ddlFields: object = { value: 'value' };

    useEffect(() => {
        getBrands();
        getProducts();

    }, []);

    const getBrands = async () => {
        setLoadingBrand(true);
        BrandService.getBrandForList()
          .then((response) => {
            console.log('Brands get response', response.data.recordset);
            const mappedBrands = response.data.recordset.map((b)=>({ id: b.BrandID, value: b.BrandName }));
            setBrands(mappedBrands);
            setLoadingBrand(false);
          })
          .catch((e) => {
            console.log(e);
          });
    };

    const getProducts = async (type: string) => {
        setLoadingProduct(true);
        ProductTransferService.getForList()
          .then((response) => {
            console.log('Products get response', response.data.recordset);
            setProducts(response.data.recordset);
            setLoadingProduct(false);
          })
          .catch((e) => {
            console.log(e);
          });
      };

    const fromBrandsChange = (e)=>{
        console.log(e)
        setFromBrandValue(e?.itemData?.value ? e?.itemData?.value : '');
        setFromBrandID(e?.itemData?.id ? e?.itemData?.id : undefined);
    if (e?.e?.srcElement?.id) {
      setFromBrandID(e?.itemData?.id);
    }
    }
    const toBrandsChange = (e)=>{
        console.log(e)
        setToBrandValue(e?.itemData?.value ? e?.itemData?.value : '');
        setToBrandID(e?.itemData?.id ? e?.itemData?.id : undefined);
    if (e?.e?.srcElement?.id) {
      setToBrandID(e?.itemData?.id);
    }
    }

    const fromProductsChange = (e)=>{

        console.log(e)
        setFromProductValue(e?.itemData?.value ? e?.itemData?.value : '');
        setFromProductID(e?.itemData?.id ? e?.itemData?.id : undefined);
    if (e?.e?.srcElement?.id) {
      console.log('from product change: ', e?.itemData?.id);
      setFromProductID(e?.itemData?.id);
    }
    }
    const toProductsChange = (e)=>{

        console.log(e)
        setToProductValue(e?.itemData?.value ? e?.itemData?.value : '');
        setToProductID(e?.itemData?.id ? e?.itemData?.id : undefined);
    if (e?.e?.srcElement?.id) {
      console.log('from product change: ', e?.itemData?.id);
      setToProductID(e?.itemData?.id);
    }
    }

    const formSubmit = (e) =>{
        e.preventDefault()
        if(fromBrandID == undefined || toBrandID == undefined || fromProductID == undefined || toProductID == undefined){
            toast.error('Please select From Brand, To Brand, From Product and To Product', {
              position: "top-right",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            return;
        }
        // if(fromBrandID == toBrandID){
        //     toast.error('Cannot Transfer Same Brand!', {
        //       position: "top-right",
        //       autoClose: 10000,
        //       hideProgressBar: false,
        //       closeOnClick: true,
        //       pauseOnHover: true,
        //       draggable: true,
        //       progress: undefined,
        //     });
        //     return;
        // }
        // if(fromProductID == toProductID){
        //     toast.error('Cannot Transfer Same Product!', {
        //       position: "top-right",
        //       autoClose: 10000,
        //       hideProgressBar: false,
        //       closeOnClick: true,
        //       pauseOnHover: true,
        //       draggable: true,
        //       progress: undefined,
        //     });
        //     return;
        // }
        if (fromBrandID == toBrandID && fromProductID == toProductID) {
  toast.error('Cannot Transfer Same Brand and Same Product!', {
    position: "top-right",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  return;
}
        let params = {
          FromBrandID:fromBrandID,
          ToBrandID:toBrandID,
          FromProductID:fromProductID,
          ToProductID:toProductID
        }
        ProductTransferService.productTransferNew(params).then((res)=>{
          console.log(res)
          setToProductID(undefined)
          setToProductValue('')
          setFromProductID(undefined)
          setFromProductValue('')
          setToBrandID(undefined)
          setToBrandValue('')
          setFromBrandID(undefined)
          setFromBrandValue('')
          document.getElementById('user-replicate').style.display = 'block'
          setTimeout(()=>{
              document.getElementById('user-replicate').style.display = 'none'
          },1500)
        }).catch((e)=>{
          console.log(e)
          toast.error(e?.response?.data?.message || e?.message || 'Product Transfer Failed', {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
    }

    return (
        (props.isDialog) ? (

        <div>

        </div>
        ) :
        (
            <div className="content-wrapper">
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                  <div>
                    <h3> Product - Transfer</h3>
                    <form onSubmit={formSubmit}>


                    <div className='user-replicate'>
                  <div className='transfer-row'>
                  <div className='first-dropdown'>

                    <mat-form-field>
                      {loadingBrand ? (
                        <div>... Loading  From Brands </div>
                      ) : (
                        <div>
                          <AutoCompleteComponent
                            id='FromBrand'
                            dataSource={brands}
                            placeholder='Select  From Brand'
                            fields={ddlFields}
                            floatLabelType='Auto'
                            highlight={true}
                            select={fromBrandsChange}
                            ref={frombrandsRef}
                            focus={()=>{
                              if (frombrandsRef ) {frombrandsRef.current.showPopup();}
                            }}
                            change={fromBrandsChange}
                            value={fromBrandValue}
                              blur={()=>{
                                if (fromBrandID  == undefined  || frombrandsRef.current.value == null || frombrandsRef.current.value == '' || fromBrandID == undefined || fromBrandID == null) {
                                 if(fromBrandValue != ''){
                                   let resstr = brands.some(e=>e.value ==  fromBrandValue);
                                   if(resstr === false){
                                     document.getElementById("FromBrand").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                       document.getElementById("FromBrand").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'

                                     }, 1000);
                                   }
                                 }
                               }
                             }}
                          />

                          <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            name='FromBrandID'
                            floatLabelType='Auto'
                            value={fromBrandID}
                          />
                          </div>
                      )}
                    </mat-form-field>
                        </div>
                  <div className='second-dropdown'>

                    <mat-form-field>
                      {loadingBrand ? (
                        <div>... Loading  To Brands </div>
                      ) : (
                        <div>
                          <AutoCompleteComponent
                            id='ToBrand'
                            dataSource={brands}
                            placeholder='Select To Brand'
                            fields={ddlFields}
                            floatLabelType='Auto'
                            highlight={true}
                            select={toBrandsChange}
                            ref={tobrandsRef}
                            focus={()=>{
                              if (tobrandsRef ) {tobrandsRef.current.showPopup();}
                            }}
                            change={toBrandsChange}
                            value={toBrandValue}
                              blur={()=>{
                                if (toBrandID  == undefined  || tobrandsRef.current.value == null || tobrandsRef.current.value == '' || toBrandID == undefined || toBrandID == null) {
                                 if(toBrandValue != ''){
                                   let resstr = brands.some(e=>e.value ==  toBrandValue);
                                   if(resstr === false){
                                     document.getElementById("ToBrand").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                       document.getElementById("ToBrand").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'

                                     }, 1000);
                                   }
                                 }
                               }
                             }}
                          />

                          <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            name='ToBrandID'
                            floatLabelType='Auto'
                            value={toBrandID}
                          />
                          </div>
                      )}
                    </mat-form-field>
                        </div>
                        </div>
                  <div className='transfer-row'>
                  <div className='first-dropdown'>

                    <mat-form-field>
                      {loadingProduct ? (
                        <div>... Loading  From Products </div>
                      ) : (
                        <div>
                          <AutoCompleteComponent
                            id='FromProduct'
                            dataSource={products}
                            placeholder='Select  From Product'
                            fields={ddlFields}
                            floatLabelType='Auto'
                            highlight={true}
                            select={fromProductsChange}
                            ref={fromproductsRef}
                            focus={()=>{
                              if (fromproductsRef ) {fromproductsRef.current.showPopup();}
                            }}
                            change={fromProductsChange}
                            value={formProductValue}
                              blur={()=>{
                                console.log('dfdfblur',fromProductID)
                                if (fromProductID  == undefined  || fromproductsRef.current.value == null || fromproductsRef.current.value == '' || fromProductID == undefined || fromProductID == null) {
                                 if(formProductValue != ''){
                                   let resstr = products.some(e=>e.value ==  formProductValue);
                                   console.log(resstr)
                                   if(resstr === false){
                                    //  setProductGroupErorr(`${designationValue} Value Not Find ` )
                                     document.getElementById("FromProduct").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                      //  setProductItemTypeError('')
                                       document.getElementById("FromProduct").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'

                                     }, 1000);
                                   }
                                 }
                                //  if (addNewClicked == false){
                                //   fromproductsRef.current.element.focus()

                                //  }
                               }
                             }}
                          />

                          <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            name='FromProductID'
                            floatLabelType='Auto'
                            value={fromProductID}
                          />
                          </div>
                      )}
                    </mat-form-field>
                        </div>
                  <div className='second-dropdown'>

                    <mat-form-field>
                      {loadingProduct ? (
                        <div>... Loading  To Products </div>
                      ) : (
                        <div>
                          <AutoCompleteComponent
                            id='ToProduct'
                            dataSource={products}
                            placeholder='Select To Product'
                            fields={ddlFields}
                            floatLabelType='Auto'
                            highlight={true}
                            select={toProductsChange}
                            ref={toproductsRef}
                            focus={()=>{
                              if (toproductsRef ) {toproductsRef.current.showPopup();}
                            }}
                            change={toProductsChange}
                            value={toProductValue}
                              blur={()=>{
                                console.log('dfdfblur',toProductID)
                                if (toProductID  == undefined  || fromproductsRef.current.value == null || fromproductsRef.current.value == '' || toProductID == undefined || toProductID == null) {
                                 if(toProductValue != ''){
                                   let resstr = products.some(e=>e.value ==  toProductValue);
                                   console.log(resstr)
                                   if(resstr === false){
                                    //  setProductGroupErorr(`${designationValue} Value Not Find ` )
                                     document.getElementById("ToProduct").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                      //  setProductItemTypeError('')
                                       document.getElementById("ToProduct").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'

                                     }, 1000);
                                   }
                                 }
                                //  if (addNewClicked == false){
                                //   fromproductsRef.current.element.focus()

                                //  }
                               }
                             }}
                          />

                          <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            name='ToProductID'
                            floatLabelType='Auto'
                            value={toProductID}
                          />
                          </div>
                      )}
                    </mat-form-field>
                        </div>
                        </div>
                        <div className='div-btn'>
                        <button
                        type='submit'
                        id='get-data-btn'
                        className='user-replicate-btn'
                        > Product Transfer</button>
                        <p id='user-replicate'> Product Transfer SuccessFully!</p>
                        </div>
                      </div>
                      </form>
                 </div>
            </div>
        )
    );
}

export default ProductTransfer;
